import { createAction } from 'redux-actions';
export const RESET_WEBSITE_FLOWS = '@@lib/REQUEST_REMOVE_WEBSITE_FLOWS';
const resetWebsiteFlows = createAction(RESET_WEBSITE_FLOWS);
export default resetWebsiteFlows;